const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "#F6F6FB",
    style: {
      fill: "#F6F6FB",
      fill: "color(display-p3 0.9647 0.9647 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#D9E5F8",
    style: {
      stroke: "#D9E5F8",
      stroke: "color(display-p3 0.8494 0.8973 0.9718)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8946 7L16 9.34513H15.7329C15.6813 8.93215 15.611 8.63717 15.522 8.46018C15.3767 8.17502 15.1822 7.96608 14.9385 7.83333C14.6995 7.69567 14.3831 7.62684 13.9895 7.62684H12.6467V15.267C12.6467 15.8815 12.71 16.265 12.8366 16.4174C13.0146 16.6239 13.2888 16.7271 13.6591 16.7271H13.9895V17H9.94728V16.7271H10.2847C10.6878 16.7271 10.9736 16.5993 11.1424 16.3437C11.2455 16.1863 11.297 15.8274 11.297 15.267V7.62684H10.1511C9.70592 7.62684 9.38957 7.66126 9.20211 7.73009C8.95841 7.8235 8.74985 8.00295 8.57645 8.26844C8.40305 8.53392 8.29994 8.89282 8.26714 9.34513H8L8.11248 7H15.8946Z",
    fill: "#C6C2EF",
    style: {
      fill: "#C6C2EF",
      fill: "color(display-p3 0.7765 0.7608 0.9373)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTitle);
export default __webpack_public_path__ + "static/media/question-title.e834f56eb743c9b2787aaf48498266f6.svg";
export { ForwardRef as ReactComponent };